import React from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const Print = ({ ultrasound }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  return (
    <ThermalReceipt
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      rows={[
        { label: `${t("print.patient")}:`, value: ultrasound?.patient_display || "-" },
        { label: `${t("print.type")}:`, value: ultrasound?.ultrasound_type_display || "-" },
      ]}
      totals={[{ label: t("print.totalAmount"), value: money(ultrasound?.total_amount), bold: true }]}
      footerLines={[t("print.thanks"), t("print.getWellSoon"), t("print.cosmos")]}
    />
  );
};

export default Print;
